export enum LoadingState {
  Empty,
  Loading,
  Data,
  Error
}
